// Canned drop/nurture reasons — MIRROR of server/lib/leadReasons.js (the
// server allow-list validates against its copy; keep them identical).

export const DROP_REASONS = [
  'Not interested',
  "Doesn't want a paid service",
  'Went with another company or VSO',
  'Doing it on their own with the VA',
  'Already at their goal rating',
  'Asked us to stop contacting them',
  'Texted STOP',
  'Wrong number or bad contact info',
  'Duplicate lead',
  'Other',
];

export const NURTURE_REASONS = [
  "Couldn't book a follow-up",
  'Needs more time to decide',
  'Asked us to follow up later',
  'Waiting on a VA decision',
  'Deployed or unavailable for now',
  'Money is tight right now',
  'Medical or family situation',
  'Other',
];
